import React, { useState, useEffect } from "react"
import { SettingsTitle } from "../components/ui/settings/settings-title"
import { AccountPreferences } from "../components/ui/settings/account-preferences"
import { NotificationSettings } from "../components/ui/notification-settings"
import { PrivacyControls } from "../components/ui/settings/privacy-controls"
import { AppPreferences } from "../components/ui/settings/app-preferences"
import { Sidebar } from "../components/ui/sidebar"
import { UniversalSearch } from "../components/ui/universal-search"
import {AIChatBox} from "../components/ui/ai-chat-box";
import ProtectedRoute from "../components/ProtectedRoute"

const Settings = () => {
  const [isClient, setIsClient] = useState(false);

  useEffect(() => {
    setIsClient(true);
  }, []);

  const handleSearch = (query) => {
    console.log("Universal search for:", query)
  }

  return (
   <ProtectedRoute>
     <div className="flex min-h-screen bg-slate-200">
        {/* Sidebar - Handles its own mobile logic internally */}
        <Sidebar />

        <AIChatBox />

        {/* Universal Search Component */}
        <UniversalSearch onSearch={handleSearch} />

        {/* Main Content */}
        <main
          className="
            flex-1 p-3 sm:p-4 md:p-6 lg:p-8 w-full min-h-screen overflow-y-auto
            transition-all duration-300 ease-in-out
            lg:ml-64  /* ensures sidebar space is reserved on desktop */
          "
        >
          {/* Mobile Header Spacing for Fixed Hamburger (from Sidebar) */}
          <div className="md:hidden h-16 mb-4"></div>

          {/* Mobile Header Content */}
          <div className="md:hidden flex items-center gap-3 mb-6 pb-4 border-b border-slate-200">
            <div className="flex-1">
              <h1 className="text-xl font-bold text-slate-900">Settings</h1>
              <p className="text-sm text-slate-600">Manage your preferences</p>
            </div>
          </div>

          <div className="max-w-5xl mx-auto">
            {/* Desktop Header */}
            <div className="hidden md:block">
              <SettingsTitle />
            </div>

            {/* Settings Grid */}
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 sm:gap-6 md:gap-8 mb-8 sm:mb-12">
              <AccountPreferences />
              <NotificationSettings />
              <PrivacyControls />
              <AppPreferences />
            </div>
          </div>
        </main>
      </div>
   </ProtectedRoute>
  )
}

export default Settings